import statusColors from './statusColors';
import tripStatuses from './tripStatuses';
import orderStatuses from './orderStatuses';
import economicalStatuses from './economicalStatuses';
import operationalStatuses from './operationalStatuses';
import economicalStatusColors from './economicalStatusColors';

export default {
	trip: tripStatuses,
	order: orderStatuses,
	color: statusColors,
	economical: economicalStatuses,
	economicalStatusColor: economicalStatusColors,
	operational: operationalStatuses,
};
